<div class="progress-bar-wrapper" [ngStyle]="{'width': progressWrapperWidth}">
  <progressbar [max]="progressMax" [animate]="progressAnimate" [value]="progressValue" [type]="progressType">
    @if (showValueInBar) {
      <div> {{progressValue}}%</div>
    }
  </progressbar>
</div>